import Vue from "vue";
import PageTitle from "@/components/Title/PageTitle.vue";
import HalfBlockTitle from "@/components/Title/HalfBlockTitle.vue";
import FullBlockTitle from "@/components/Title/FullBlockTitle.vue";

Vue.component("PageTitle", PageTitle);
Vue.component("FullBlockTitle", FullBlockTitle);
Vue.component("HalfBlockTitle", HalfBlockTitle);
